@if (canInstall() && !dismissed()) {
<div class="fixed left-3.5 right-3.5 z-30 flex items-center gap-3 rounded-2xl px-4 py-3 shadow-lg bg-gradient-to-br from-primary-600 to-primary-800 text-white"
     style="bottom: calc(env(safe-area-inset-bottom, 0px) + 88px);">
    <div class="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center flex-none">
        <lucide-icon [img]="Download" [size]="20" class="text-white"></lucide-icon>
    </div>
    <div class="flex-1 min-w-0">
        <div class="text-sm font-bold truncate">{{ t().pwa.install_title }}</div>
        <div class="text-xs text-white/75 truncate">{{ t().pwa.install_body }}</div>
    </div>
    <button (click)="install()" class="flex-none px-3 py-2 rounded-lg bg-white text-primary-700 text-xs font-bold">
        {{ t().pwa.install_action }}
    </button>
    <button (click)="dismiss()" class="flex-none p-1.5 rounded-full hover:bg-white/10" [attr.aria-label]="t().pwa.install_dismiss">
        <lucide-icon [img]="X" [size]="16" class="text-white/70"></lucide-icon>
    </button>
</div>
}
